import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { Link } from "react-router-dom";
import { PATH_SETTINGS_ACCOUNT_INFO } from "../../Settings/paths";
import { PAYERS_PATH } from "../../Payers/paths";

type Props = WSModalCustomProps<void>;

/**
 * Explains how to change the pre-filled (read-only) data the contractor can only
 * verify on a form: personal details live in Account Settings; employer details
 * come from the employer. Opened from the "Need to make a change?" link on the
 * Pre-filled data card.
 */
export const ModalNeedToMakeAChange: React.FC<Props> = ({ ...modalProps }) => (
  <WSModal
    title="Need to make a change?"
    size="S"
    actions={{
      buttons: [
        {
          kind: "Secondary",
          label: "Close",
          onClick: () => modalProps.onClose()
        }
      ]
    }}
    {...modalProps}
  >
    <WSList gap="M">
      <WSText.ParagraphSm color="gray600">
        Your details (name, SSN, date of birth): update these in Account
        Settings, then come back to finish your form.{" "}
        <Link
          to={PATH_SETTINGS_ACCOUNT_INFO}
          onClick={() => modalProps.onClose()}
        >
          <WSText.ParagraphSm inline color="blue500">
            Go to Account settings
          </WSText.ParagraphSm>
        </Link>
      </WSText.ParagraphSm>
      <WSText.ParagraphSm color="gray600">
        Employer details (company name, EIN, address): these come from your
        employer. Check your{" "}
        <Link to={PAYERS_PATH} onClick={() => modalProps.onClose()}>
          <WSText.ParagraphSm inline color="blue500">
            Employer profile
          </WSText.ParagraphSm>
        </Link>{" "}
        or reach out to them directly to fix anything.
      </WSText.ParagraphSm>
    </WSList>
  </WSModal>
);

export const useModalNeedToMakeAChange = () =>
  useWSModalCustom(ModalNeedToMakeAChange);
